import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { NewsPost } from '../../models/news-post';
import { ReduxDispatch } from '../../../../../store/use-thunk-dispatch';

export const NEWS_POST_LIST_FETCH = 'NEWS_POST_LIST_FETCH';
export const NEWS_POST_LIST_RECEIVE = 'NEWS_POST_LIST_RECEIVE';
export const NEWS_POST_LIST_ERROR = 'NEWS_POST_LIST_ERROR';

export const receiveNewsPostList = (newsPosts: PaginatedResponse<NewsPost>) => {
    return {
        type: NEWS_POST_LIST_RECEIVE,
        newsPosts,
    };
};

export const fetchNewsPostList = (searchParams: URLSearchParams = new URLSearchParams()) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: NEWS_POST_LIST_FETCH });
        const response = await api.contentManagement.NewsPost.NewsPostList.getNewsPosts(searchParams);
        if (response.success) {
            dispatch(receiveNewsPostList(response.result));
        } else {
            dispatch({ type: NEWS_POST_LIST_ERROR });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
